import React, { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import SubNav from './SubNav';
import { ACH_BATCHES_WITH_COUNT } from './queries';
import { MainContainer } from '../../../elements';
import { ContentContainer, PageTitle, LinkContainer } from '../../../elements';
import AchBatchModal from '../../Sales/AchBatchModal';

import Modal from 'app/src/elements/Modal';
import { dateShort, datetimeShort } from 'app/src/utils/timeFormatter';

const AchBatches = () => {
  const [showAchBatchModal, setShowAchBatchModal] = useState(false);
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const { data } = useQuery(ACH_BATCHES_WITH_COUNT,
    { variables: queryVariables }
  );

  const columns = [
    {
      key: 'bankDate',
      label: 'Bank Date',
      sort: 'desc',
      content: ({ value }) => dateShort(value),
    },
    {
      key: 'sentAt',
      label: 'Sent At',
      sort: 'desc',
      content: ({ value }) => (value ? datetimeShort(value) : 'CURRENT'),
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => (
        <Pressable
          onPress={() => setShowAchBatchModal(entry)}
        >
          View
        </Pressable>
      )
    },
  ];

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px'}}>
          <Filter.DateRange
            columnKey="bank_date"
            label="Bank Date"
            filters={filters}
            setFilter={setFilter}
          />
          <Filter.DateRange
            columnKey="sentAt"
            label="Sent At"
            filters={filters}
            setFilter={setFilter}
          />
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      {/* <SubNav refetch={refetch} selects={data} /> */}

      <ContentContainer>
        <PageTitle>ACH Batches</PageTitle>

        <DataTable.Gql
          setRefetch={setRefetch}
          query={ACH_BATCHES_WITH_COUNT}
          queryName='achBatchesWithCount'
          queryVariables={queryVariables}
          columns={columns}
          pageLength={25}
          buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.achBatchesWithCount)}
          htmlTable
        />
        {showAchBatchModal &&
          <Modal
            setShowModal={setShowAchBatchModal}
            modalType={`${dateShort(showAchBatchModal.bankDate)} ACH Batch`}
          >
            <AchBatchModal
              setShowModal={setShowAchBatchModal}
              achBatch={showAchBatchModal}
              editable={false}
              noExcel={false}
              noPdf={true}
            />
          </Modal>
        }
      </ContentContainer>
    </MainContainer>
  )


}

export default AchBatches;
